import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ element, requiredRoles }) => {
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredRoles && requiredRoles.length > 0) {
        const hasRequiredRole = requiredRoles.includes(userdata?.user_type);

        if (!hasRequiredRole) {
            // switch (userdata?.user_type) {
            //     case 'User':
            //         return <Navigate to="/" state={{ from: location }} replace />;
            //     case 'Super Admin':
            //         return <Navigate to="/dashboard" replace />;
            //     default:
            //         return <Navigate to="/" replace />;
            // }
            switch (userdata?.user_type) {
                case 'User':
                    return <Navigate to="/" state={{ from: location }} replace />;
                default:
                    return <Navigate to="/dashboard" replace />;
            }
        }
    }

    return element;
};

export default ProtectedRoute;